import { RouteItem } from '@eastcoal/router/types/route'

import { KIND_PAGE_PATH } from './constants/path'
import { KIND_PAGE_UUID, KIND_ACTION_UUID } from './constants/uuids'

export const kindRoute: RouteItem = {
  title: '品种管理',
  path: KIND_PAGE_PATH,
  uuid: KIND_PAGE_UUID,
  Component: () => import('./index'),
  children: [
    {
      title: '管理品种',
      uuid: KIND_ACTION_UUID
    }
  ]
}
